<template>
  <div class="task-item">
    <div class="task-info">
      <div class="task-title">{{ formatTimestamp(item.endTime) }}</div>
      <div class="task-time">
        有效期：{{ item.beginTimeStr }}-{{ item.endTimeStr }}
        <span v-show="item.finishStatus == 0 && timeShow" class="count-down">
          {{ time }}
        </span>
      </div>
    </div>
    <div
      v-if="item.finishStatus == 0"
      class="task-btn normal"
      :class="{ disabled: time === '已过期' || notStartedYet }"
      @click="goDetail"
    >
      <span v-if="time === '已过期'">已过期</span>
      <span v-else-if="notStartedYet">未开始</span>
      <span v-else>去完成</span>
    </div>
    <div v-else-if="item.finishStatus == 1" class="task-btn complete">
      <van-icon name="success" style="margin-right: 0.06rem" />已完成
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      time: '',
      timer: null,
      timeShow: false,
      notStartedYet: false
    }
  },
  created() {
    this.time = this.getTime(this.item.endTime * 1000)
  },
  mounted() {
    if (Number(this.item.finishStatus) === 0) {
      this.timer = setInterval(() => {
        this.time = this.getTime(this.item.endTime * 1000)
      }, 1000)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    goDetail(item) {
      if (this.time && this.time !== '已过期' && !this.notStartedYet) {
        this.$router.push({
          name: 'taskDetail',
          query: {
            configId: this.item.configId,
            beginTime: this.item.beginTime,
            endTime: this.item.endTime
          }
        })
      }
    },
    getTime(timestamp) {
      const currentTime = new Date().getTime()
      const timeDifference = timestamp - currentTime

      this.notStartedYet = this.item.beginTime * 1000 > currentTime

      if (timeDifference <= 0) {
        clearInterval(this.timer)
        this.timeShow = false
        return '已过期'
      }
      let hours = Math.floor(
        (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      )
      this.timeShow = hours <= 2
      let minutes = Math.floor(
        (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
      )
      let seconds = Math.floor((timeDifference % (1000 * 60)) / 1000)

      const insertZero = num => {
        return num < 10 ? '0' + num : num
      }
      hours = insertZero(hours)
      minutes = insertZero(minutes)
      seconds = insertZero(seconds)
      return `剩余${hours}:${minutes}:${seconds}`
    },
    formatTimestamp(timestamp) {
      const timestampInMilliseconds = timestamp * 1000
      const date = new Date(timestampInMilliseconds)

      const year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      const insertZero = num => {
        return num < 10 ? '0' + num : num
      }
      month = insertZero(month)
      day = insertZero(day)

      return `${year}-${month}-${day}`
    }
  }
}
</script>

<style lang="scss" scoped>
.task-item {
  width: 100%;
  height: 1.54rem;
  display: flex;
  justify-content: space-between;
  padding: 0.32rem;
  box-sizing: border-box;
  .task-info {
    .task-title {
      font-size: 0.32rem;
      font-weight: 500;
      color: #262626;
      margin-bottom: 0.12rem;
    }
    .task-time {
      font-size: 0.24rem;
      color: #8c8c8c;
      .count-down {
        color: #ff3410;
        margin-left: 0.12rem;
      }
    }
  }
  .task-btn {
    align-self: center;
    width: 1.78rem;
    height: 0.6rem;
    line-height: 0.6rem;
    text-align: center;
    border-radius: 0.31rem;
    font-size: 0.28rem;
    &.normal {
      background-image: linear-gradient(137deg, #ff7d5e 2%, #ff3410 98%);
      color: #ffffff;
    }
    &.disabled {
      background-image: linear-gradient(137deg, #f0a390 2%, #f59482 98%);
      color: #ffffff;
    }
    &.complete {
      background-color: #fff4f4;
      color: #ff3410;
    }
  }
}
</style>
